import { moneyFormatNoDecimal, Slider, Stack, Text } from "@sveabank/cc-common";
import { Field } from "react-final-form";

type Props = {
	name: string;
	min: number;
	max: number;
};
const CreditConfigSlider = ({ name, min, max }: Props) => (
	<div className="mt-4">
		<Stack direction="row" justify="between" align="center">
			<Text className="text-text-headline text-lg" bold>
				{moneyFormatNoDecimal(min, true)}
			</Text>
			<Text className="text-text-headline text-lg" bold>
				{moneyFormatNoDecimal(max, true)}
			</Text>
		</Stack>
		<Field name={name}>
			{({ input }) => (
				<>
					<Slider
						value={Number(input.value)}
						minValue={min}
						maxValue={max}
						step={1000}
						aria-label="Välj kreditgräns"
						onChange={(value) => {
							input.onChange(value.toString());
						}}
					/>
				</>
			)}
		</Field>
	</div>
);

export default CreditConfigSlider;
